import React from 'react'
import PdfPage from '../components/PdfPage'
import "./index.css"

const PsxRuleBook = () => {
  return (
    <main>
      <PdfPage
        h2={"Psx Rule Book"}
        img={"/img/PSX-logo.jpg"}
        pdf1={"https://api.orbitsecurities.com.pk/media/cms/documents/psx-rule-book-english.pdf"}
        pdf1Text={"Download File In English"}
        pdf2={"https://api.orbitsecurities.com.pk/media/cms/documents/psx-rule-book-urdu.pdf"}
        pdf2Text={"Download In Urdu"}
      />
    </main>)
}

export default PsxRuleBook